import { defaultState as defaultUterum } from "../../../Uterum/defaultState";

/*
Continue if Uterum is not equal to defaultUterum
or if thunk is dispatched with some additional property/-ies
*/
export const conditionRuleset = {
  condition: (data = {}, thunkAPI) => {
    const state = thunkAPI.getState();
    const { Uterum } = state;

    return (
      JSON.stringify(Uterum) !== JSON.stringify(defaultUterum) ||
      Object.values(data).some((value) => (value ? true : false))
    );
  },
  // Will dispatch 'rejected' action for error handling, if condition is not met
  dispatchConditionRejection: true,
};
